import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import OutfitModal from "./OutfitModal";
import ProductTag from "./ProductTag";

const OutfitCanvas = (props: any) => {
  const { recommendation } = props;

  const canvasRef = React.useRef<HTMLCanvasElement>(null);
  const [context, setContext] = React.useState<CanvasRenderingContext2D | null>(
    null
  );

  useEffect(() => {
    if (canvasRef.current) {
      const renderContext = canvasRef.current.getContext("2d");

      if (renderContext) {
        setContext(renderContext);
      }

      if (context) {
        const topImage = new Image();
        const bottomImage = new Image();
        const shoeImage = new Image();

        bottomImage.onload = () => {
          const ratio = bottomImage.width / bottomImage.height;
          let width = 150;
          let height = width / ratio;
          if (height > 220) {
            height = 220;
            width = 220 * ratio;
          }
          context.imageSmoothingQuality = "high";
          context.drawImage(bottomImage, 100, 200, width, height);
        };
        bottomImage.src = recommendation[1].image_url;

        topImage.onload = () => {
          const ratio = topImage.width / topImage.height;
          const height = 180;
          const width = height * ratio;
          context.imageSmoothingQuality = "high";
          context.drawImage(topImage, 30, 30, width, height);
        };
        topImage.src = recommendation[0].image_url;

        shoeImage.onload = () => {
          const ratio = shoeImage.width / shoeImage.height;
          const height = 140;
          const width = height * ratio;
          context.imageSmoothingQuality = "high";
          context.drawImage(shoeImage, 260, 300, width, height);
        };
        shoeImage.src = recommendation[2].image_url;
      }
    }
  }, [context, recommendation]);

  return (
    <Wrapper>
      <Canvas width={400} height={470} ref={canvasRef}></Canvas>
      <OutfitModal
        id={"outfitModal"}
        recommendation={recommendation}
      ></OutfitModal>
      <Link
        to={`/products/${recommendation[0].id}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <ProductTag
          name={`${recommendation[0].brand} ${recommendation[0].name}`}
          color={"#000000"}
          className={"topTag"}
        />
      </Link>
      <Link
        to={`/products/${recommendation[1].id}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <ProductTag
          name={`${recommendation[1].brand} ${recommendation[1].name}`}
          color={"#000000"}
          className={"bottomTag"}
        />
      </Link>
      <Link
        to={`/products/${recommendation[2].id}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <ProductTag
          name={`${recommendation[2].brand} ${recommendation[2].name}`}
          color={"#000000"}
          className={"shoeTag"}
        />
      </Link>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;

  .topTag {
    position: absolute;
    top: 20px;
    left: 28px;
    opacity: 0;
  }

  .bottomTag {
    position: absolute;
    top: 220px;
    right: 40px;
    opacity: 0;
  }

  .shoeTag {
    position: absolute;
    right: 10px;
    bottom: 30px;
    opacity: 0;
  }

  .viewButton {
    position: absolute;
    left: 24px;
    bottom: 20px;
  }

  &:hover {
    .viewButton {
      width: 110px;
    }

    .topTag {
      opacity: 0.9;
    }

    .bottomTag {
      opacity: 0.9;
    }

    .shoeTag {
      opacity: 0.9;
    }
  }
`;

const Canvas = styled.canvas`
  background: #f5f5f5;
`;

export default OutfitCanvas;
